import {DashboardBarsCell} from "./DashboardBarsCell";
import React from "react";
import {GoalDayBar} from "./day_bars/GoalDayBar";
import {EditGoalModal} from "../../../../client/EditGoalModal";
import {COLUMN_CELL_INVALID_CONTENT} from "../../../columns";

export class DashboardGoalBarsCell extends DashboardBarsCell {
    constructor(props) {
        super(props);
        this.handleGoalModified = this.handleGoalModified.bind(this);
    }

    renderDayBar(dayNumber, alertLevel, alertData, isToday, alert_snoozed, rowType, goal_value, metric_name) {
         return <GoalDayBar key={dayNumber}
                           dayNumber={dayNumber + 1}
                           alertLevel={alertLevel}
                           fluctuation={alertData.fluctuation}
                           fluctuationPercentage={alertData.fluctuation_percentage}
                           value={alertData.formatted_value}
                           expectedValueOnDay={alertData.formatted_expected_value}
                           isToday={isToday}
                           isSnoozed={this.props.data.alert_snoozed}
                           rowType={rowType}
                           formattedGoalValue={alertData.formatted_goal_value}
                           metricName={this.props.data.metric_name}
                           valueByType={alertData.conversions_by_action_name_until_datetime !== undefined ? alertData.conversions_by_action_name_until_datetime : {}}
                           dayValueByType={alertData.conversions_by_action_name_for_date !== undefined ? alertData.conversions_by_action_name_for_date : {}}
                           dayValue={alertData.formatted_day_value}
                           businessUnitId={this.props.businessUnitId}
                           priority={this.props.priority}
        />;
    }

    hasGoal() {
        return this.props.data.has_goal;
    }

    renderEditInModalIcon() {
        return <EditGoalModal onFormSubmitted={this.handleGoalModified}
                              businessUnitId={this.props.businessUnitId}
                              campaignsConfigurationId={this.props.campaignsConfigurationId}
                              campaignId={this.props.campaignId}
                              adgroupId={this.props.adgroupId}
                              priority={this.props.priority}
                              clickOutsideDontCloseModal={true}
        />
    }

    handleGoalModified(data) {
        this.props.onGoalUpdated(this.props.campaignId, this.props.adgroupId, data)
    }

    classIfHasGoal() {
        if (this.hasGoal()) {
            return "widther"
        }
        return "small";
    }

    render() {
        let content = null;

        if (this.hasGoal()) {
            let pastAndTodayBars = this.barsForPastDaysAndToday();
            content = this.addFutureDaysBars(pastAndTodayBars);
        } else {
            content = [COLUMN_CELL_INVALID_CONTENT]
        }

        return (
            <td className={`graphic-data ${this.classIfHasGoal()} ${this.processingCssClasses()}`}>
                <div className="graphic-goals">
                    {content}{this.renderEditInModalIcon()}
                </div>
            </td>
        );
    }
}
